import { ref } from 'vue'
import Modal from '@/components/modals/Modal.vue'

const premiumMembershipModal = ref<InstanceType<typeof Modal>>()
const premiumProcessorType = ref<string>()

export default function usePremiumMembershipModal() {
  function openPremiumMembershipModal(processorType: string) {
    premiumProcessorType.value = processorType
    premiumMembershipModal.value?.show()
  }

  function hidePremiumMembershipModal() {
    premiumMembershipModal.value?.hide()
  }

  return {
    premiumMembershipModal,
    premiumProcessorType,
    openPremiumMembershipModal,
    hidePremiumMembershipModal,
  }
}
